

















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import MenuMain from '@/shared/side-bar/mandala-side-bar-menu.component.vue';
import MenuProject from '@/shared/side-bar/mandala-side-bar-projects.component.vue';
import ProjectUserStore from '@/domain/project/project-with-members.store';


@Component({
  components: {
    MenuMain,
    MenuProject,
  },
})

export default class MandalaSideBarComponent extends Vue {
  private projectsStore = getModule(ProjectUserStore);

  private drawer: boolean = true;

  private mini: boolean = true;

  private right: any = null;

  private itemsMenu: any = [
    {
      title: 'home',
      path: '/',
      icon: 'home',
    },
    {
      title: 'Horas Task x Ponto',
      path: '/horas',
      icon: 'alarm',
    },
    {
      title: 'Pesquisa de Satisfação',
      path: '/pesquisa-satisfacao',
      icon: 'star',
    },
  ];

   private subItems: any = [
     {
       icon: 'home',
       name: 'home',
       path: 'home',
     },
     {
       icon: 'view_list',
       name: 'workitems',
       path: 'work-items',
     },
     {
       icon: 'remove_from_queue',
       name: 'monitor',
       path: 'monitor',
     },
   ];

   created() {
     this.projectsStore.fetchProjects();
   }

   get projectList() {
     return this.projectsStore.getAllProjectsUser;
   }
}
